var $resultTable = null;
var $sortLabels = null;

$(document).ready(function() {
	
	$resultTable = $('#link-table [class=item]');
	$sortLabels = $(".sortselect");
	
	$( document ).trigger( "hotel_filter_event");
	
	
	hotelSearchFilter.init();
	hotelSortFilter.init();
	
});

$( ".hotel-filter" ).tabs();

$("#showFilter").click(function() {
	$('.resultLeft').fadeToggle("fast");
	return false;
});

$(".pop-btn-ok").click(function() {
	$('.resultLeft,.pop-sorting').hide();
	return false;
});

var hotelSearchFilter = function() {

	
	var $nameFilter = $("#filterByName");
	var $stars = $(".filterByStar");
	var $boards = $(".filterByBoard");
	var $nonRefundable = $(".filterByNonRefundable");
	
	this.init = function (){
		
		$("#filterByName").keyup(function() {
			applyFilter();
		});
		
		$("input[type='checkbox'][id='filterByAvail']").click(function() {
			applyFilter();
		});
		
		$("input[type='checkbox'][class='filterByStar']").click(function() {
			applyFilter();
			$('#resetFilterStar').show();
		});

		$("input[type='checkbox'][class='filterByBoard']").click(function() {
			applyFilter();
			$('#resetFilterBoard').show();
		});
		
		$("input[type='checkbox'][class='filterByNonRefundable']").click(function() {
			applyFilter();
			$('#resetFilterIsRefundable').show();
		});
	
		
		if($resultTable != null){
			
			var minPrice = $($resultTable.first()).attr("price");
			var maxPrice = $($resultTable.last()).attr("price");
			var minSliderValue = parseInt(minPrice / 10, 10) * 10;
			var maxSliderValue = parseInt(maxPrice / 10, 10) * 10 + 10;
			
			//PRICE SLIDER #1
			$("#slider-range1").slider({
				range: true,
				min: minSliderValue,
				max: maxSliderValue,
				values: [ minSliderValue, maxSliderValue ],
				step: 10,
				slide: function(event, ui) {
					$("#filterByPrice").val(ui.values[0] + " " + $.cookie('currency') + " - " + ui.values[1] + " " + $.cookie('currency'));
				}
			});
			
			$("#filterByPrice").val($("#slider-range1").slider("values", 0) + " " + $.cookie('currency') + " - " + $("#slider-range1").slider("values", 1) + " " + $.cookie('currency'));
			
			$("#slider-range1").slider({change: function(event, ui) {
				applyFilter();
			}});
			
			//SCORE SLIDER
			$("#slider-range2").slider({
				range: "max",
				min: 0,
				max: 10,
				step: 0.5,
				value:0,
				slide: function(event, ui) {
					if(ui.value == 0){
						$("#filterByScore").val(''+FmtMessage.getMessage('js.filter.hotel.whole')+'')

					}
					else{
						$("#filterByScore").val(ui.value+'+');
					}
					
				}
			});
			
			$("#slider-range2").slider({change: function(event, ui) {
				applyFilter();
			}});
		}
		
		
		
		$("#resetFilterStar").click(function() {
			$('.filterByStar').prop("checked", true);
			applyFilter();
			$(this).hide();
		});
		
		$("#resetFilterBoard").click(function() {
			$('.filterByBoard').prop("checked", true);
			applyFilter();
			$(this).hide();
		});
		
		$("#resetFilterIsRefundable").click(function() {
			$('.filterByNonRefundable').prop("checked", true);
			applyFilter();
			$(this).hide();
		});
		

	}
	
	this.applyFilter = function() {
		var filter = getFilter();
		$resultTable.each(function(index, item){
			var show = isMatchesFilter(item, filter);
			if(show){
				$(item).show();
				$(item).attr("data-visible","true");
			}
			else{
				$(item).hide();
				$(item).attr("data-visible","false");
			}
		});
		
		$( document ).trigger( "hotel_filter_event");
        showAvailableMarkers();
	}
	
	var getFilter = function(){
		
		var stars = {}
		$stars.each(function(index, item){
			stars[item.value] = $(item).prop("checked");
		});

		var boards = {}
		$boards.each(function(index, item){
			boards[item.value] = $(item).prop("checked");
		});
		
		var nonRefundables = {}
		$nonRefundable.each(function(index, item){
			nonRefundables[item.value] = $(item).prop("checked");
		});
		
		return {
			minprice : $("#slider-range1").slider("values", 0),
			maxprice :  $("#slider-range1").slider("values", 1),
			minScore	 : $("#slider-range2").slider("value"),
			name : $nameFilter.val().toLocaleLowerCase("tr-TR"),
			stars : stars,
			boards : boards,
			nonRefundables: nonRefundables,
			hotelAvailable: $("#filterByAvail").is(":checked") ? true : false
		}
	}
	
	function _fnEscapeRegex ( sVal ) {
		var letters = { "İ": "[İi]", "I": "[İi]", "Ş": "[Şş]", "Ğ": "[Ğğ]", "Ü": "[Üü]", "Ö": "[Öö]", "Ç": "[Çç]", "i": "[İi]", "ı": "[İi]", "ş": "[Şş]", "ğ": "[Ğğ]", "ü": "[Üü]", "ö": "[Öö]", "ç": "[Çç]" };
		return sVal.replace(/(([İIŞĞÜÇÖiışğüçö]))/g, function (letter) { return letters[letter]; });
	}

	var isMatchesFilter = function(item, filter){
		
		if(filter.name.length > 0){
			
			var _name = _fnEscapeRegex(filter.name);
			var itemName = _fnEscapeRegex($(item).attr("hotelname").toLocaleLowerCase("tr-TR"));

			if(itemName.indexOf(_name) < 0){		
				return false;
			}
		} 
		
		if($(item).attr("star") in filter.stars && !filter.stars[$(item).attr("star")]){
			return false;
		}
		
		var boardlistItems = $(item).attr("boardlist");
		if(boardlistItems){
			var propertyList = boardlistItems.split(",");
			for(var pIndex in propertyList){
				if(propertyList[pIndex] in filter.boards && !filter.boards[propertyList[pIndex]]){
					return false;
				}
			}
		} else {
			return false;
		}
		
		var attr = $(item).attr("refund");
		if(attr in filter.nonRefundables && !filter.nonRefundables[attr]){
			return false;
		}
		
		if(filter.minprice > $(item).attr("price") || filter.maxprice < $(item).attr("price"))
			return false;
		
		if(filter.minScore > $(item).attr("score"))
			return false;
		
		if(filter.hotelAvailable && $(item).attr('any-available') == 'false')
			return false;
		
		
		return true;
	}
	
	return {
		init : init
	}
	
}();

var hotelSortFilter = function() {

	this.init = function (){
		
		$sortLabels.on('change', function(event){
	
			$("div.select-style.active").not(this)
				.removeClass("active").removeClass("desc");
			
			$("select.sortselect").not(this).val(0);
			
			var $this = $(this);
			var $option = $this.find(":selected");
			var attribute = $option.attr("data-filter-attribute");
			var direction = $option.attr("data-filter-direction");
			
			$this.parent().addClass("active");
			if (direction == 'desc') {
				$this.parent().addClass("dec");
			}else{
				$this.parent().removeClass("dec");
			}
			var valueType = $option.attr("data-filter-value-type");
			var hotelSortFunction = function(a, b) {
				var result;
				var valueA = $(a).attr(attribute);
				var valueB = $(b).attr(attribute);

				if (valueType == 'numeric') {
					valueA = parseFloat(valueA);
					valueB = parseFloat(valueB);
				}
				//To handle NaN score values
				if(!valueA){
					valueA = -1;
				}
				if(!valueB){
					valueB = -1;
				}
				//
				result = (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;
				if (direction == 'desc') {
					result *= -1;
				}
				return result;
			};

			$resultTable.sort(hotelSortFunction).appendTo("#hotelResultTable");

			$( document ).trigger( "hotel_filter_event");

		});
		
		// SORT BY RECOMENDED
		var sortbyRecomended = function(a, b) {
			var result;
			var valueA = $(a).attr('recomended') == 'true' ? 0 : 1;
			var valueB = $(b).attr('recomended') == 'true' ? 0 : 1;

			result = (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;

			return result;
		};
		$resultTable.sort(sortbyRecomended).appendTo("#hotelResultTable");
	}

	return {
		init : init
	}
	
}();